import { http } from '../../services/http';
import { reactLocalStorage } from 'reactjs-localstorage';

export const getArrangementsList = () => {
  return dispatch => {
    http
      .get('/arrangement/list')
      .then(response => {
        dispatch({ type: 'GET_ARRANGEMENTS_SUCCESS', data: response.data.result.list });
      })
      .catch(err => {
        dispatch({ type: 'GET_ARRANGEMENTS_ERROR', data: err });
      });
  };
};

export const getArrangement = id => {
  return dispatch => {
    http
      .post('/configure/save', { arrangementId: id })
      .then(response => {
        let height = [...response.data.result.payload].pop().dimensions.y;
        reactLocalStorage.set('wardrobeHeight', height);
        reactLocalStorage.set('token', response.data.result.token);
        reactLocalStorage.setObject('wardrobesConfigs', response.data.result.payload);

        window.location.href = `${process.env.PUBLIC_URL}/summary`;
      })
      .catch(err => {
        dispatch({ type: 'GET_ARRANGEMENTS_ERROR', data: err });
      });
  };
};
